import { render, staticRenderFns } from "./ImportResult.vue?vue&type=template&id=4c0652ca&scoped=true&"
import script from "./ImportResult.vue?vue&type=script&lang=js&"
export * from "./ImportResult.vue?vue&type=script&lang=js&"
import style0 from "./ImportResult.vue?vue&type=style&index=0&id=4c0652ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0652ca",
  null
  
)

export default component.exports